import {Link} from 'react-router';
import {ProblemStar} from '@types';
import React from 'react';
import {useTranslation} from 'react-i18next';

const StarRating: React.FC<{stars: number}> = ({stars}) => {
    return (
        <>
            {[...Array(5)].map((_, i) => (
                <i
                    key={i}
                    className={`fa-solid fa-star ${stars >= i + 1 ? 'star-colorful' : 'star-colorless'}`}
                />
            ))}
        </>
    );
};

export const ProblemStarsTable = ({stars}: {stars: ProblemStar[]}) => {
    const {t} = useTranslation();

    return (
        <table className="table table-striped table-responsive table-sm">
            <thead>
                <tr>
                    <th>{t('common.name')}</th>
                    <th>{t('common.when')}</th>
                    <th>{t('common.stars')}</th>
                </tr>
            </thead>
            <tbody>
                {stars.map((star, index) => (
                    <tr key={index}>
                        <td>
                            <Link
                                to={`/users/${star.user}`}
                                className="text-muted text-decoration-none">
                                {star.user}
                            </Link>
                        </td>
                        <td>{star.createdAt}</td>
                        <td>
                            <StarRating stars={star.stars} />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
